export default "__VITE_ASSET__5a0f276e__"